module.exports = __webpack_public_path__ + "4dab7dbe0deee73cfe556b2a9d5962c2.png";